
<template>
  <div>
    <formdialog
      :form="form"
      :shadow="false"
      v-if="startRegistration"
      :dialog="startRegistration"
      v-on:submitForm="createLabel($event)"
      v-on:rejectForm="$emit('abort')"
    ></formdialog>
  </div>
</template>
<script>
import { mapState } from "vuex";
import {
  FormPayload,
  Validator,
  FormStructField,
} from "@/components/models/FormDialog";

export default {
  name: "RegisterLabel",

  props: {
    coordinates: Object,
  },

  data: function () {
    return {
      startRegistration: false,
    };
  },

  computed: {
    ...mapState({
      labelModel: (state) => state.metadata.models.data.newLabel,
    }),

    model: function () {
      return this.labelModel;
    },
  },

  mounted: function () {
    this.startRegistration = true;
    this.buildForm();
  },

  methods: {
    async createLabel(labelModel) {
        labelModel.coordinates = this.coordinates
        await this.$store.dispatch("map/addLabel", labelModel);
        this.$emit("completed");

    },

    buildForm() {
      this.form = new FormPayload({
        title: this.model.title,
        icon: this.model.icon,
        block: false,
      });

      for (let index in this.model.fields) {
        let fieldModel = this.model.fields[index];
        let field = new FormStructField({
          name: fieldModel.name,
          label: fieldModel.label,
          type: fieldModel.type,
          icon: fieldModel.icon,
          show: fieldModel.show,
          select: !fieldModel.values
            ? this.values
              ? this.values[fieldModel.name]
              : fieldModel.values
            : fieldModel.values,
          default: fieldModel.default,
          hint: fieldModel.hint,
          disableIfDefined: fieldModel.disableIfDefined,
          if: fieldModel.if,
        });
        let validator = new Validator({
          regex: fieldModel.regexp,
          required: fieldModel.required,
          min: fieldModel.min,
          max: fieldModel.max,
        });
        field.setValidator(validator);
        this.form.addField(field);
      }
    },
  },
};
</script>